
import { mapMutations } from 'vuex';

export default {
    props: {
        items: { type: Array, required: true },
        deliveryPrice: { type: Number, default: 0 },
        totalPrice: { type: Number, required: true },
        originalPrice: { type: Number, required: false },
        discount: { type: Number, default: 0 },
        coupon: { type: Object, required: false },
        hideQuantity: { type: Boolean, default: false },
        bagFee: { type: Number, required: false },
        serviceFee: { type: Number, required: false },
        restaurantName: { type: String, required: true },
        restaurantPhone: { type: String, required: false },
        deliveryMethod: { type: String, required: false },
        corporateName: { type: String, required: false },
        isGroupOrder: { type: Boolean, required: false },
        isWhitelabel: { type: Boolean, required: false },
    },
    computed: {
        itemGroups() {
            return [...this.items].reduce((acc, value) => {
                if (!acc[value.added_by_name]) {
                    if (!value.added_by_name) {
                        if (!acc['Dig']) {
                            acc['Dig'] = [value];
                            return acc;
                        } else {
                            acc['Dig'].push(value);
                            return acc;
                        }
                    }
                    acc[value.added_by_name] = [];
                }
                acc[value.added_by_name].push(value);
                return acc;
            }, {});
        },
        groupedCartItems() {
            let foods = [...this.items];
            let results = [];
            let categories = [];
            this.items.forEach(food => {
                if (!categories.includes(food.food_category_name)) {
                    categories.push(food.food_category_name);
                }
            });
            categories.forEach(category => {
                results.push({
                    name: category,
                    foods: foods.filter(x => x.food_category_name === category),
                });
            });
            return results;
        },
    },
    methods: {
        ...mapMutations('modal', ['setModal']),
        openConceptModal() {
            this.setModal({ type: 'Concept' });
        },
    },
};
